import {Component, Input, HostListener, OnInit,Output } from '@angular/core';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
  selector: 'app-left-nav',
  templateUrl: './left-nav.component.html',
  styleUrls: ['./left-nav.component.scss']
})
export class LeftNavComponent implements OnInit {

  userType:any='';
  @Input() isCollapsed: boolean = false;
 showCreditHistory: boolean = false;
 @Input() sidebarshow = "";
 logoUrl:any = '';
 isSmallScreen = false;
 @HostListener('window:resize', ['$event'])
 onResize(event: Event): void {
   this.checkScreenSize();
 }
 constructor(
  private storageService: StorageService
) {
   if (sessionStorage.getItem('role')) {
    console.log(sessionStorage.getItem('role'));
    this.userType = sessionStorage.getItem('role');
    this.logoUrl = sessionStorage.getItem('logoUrl'); // Corrected to use 'logoUrl' as the key


  
  }


   {  if(sessionStorage.getItem('logoUrl')) {
    this.logoUrl = sessionStorage.getItem('logoUrl');
   }
  }
}

  ngOnInit(): void {
    console.log("role",sessionStorage.getItem('role'));
    this.checkScreenSize();
    let userAccess = this.storageService.userPrivilage;
    this.showCreditHistory = userAccess.includes('SHOW_CREDIT_HISTORY');
  }
  checkScreenSize(): void {
    this.isSmallScreen = window.innerWidth <= 768; // Adjust the breakpoint as needed
  }
  
}
